import { SimpleTextProcessor, ComplexTextProcessor } from './textProcessing';

function checkNode(node: Node): boolean {
  // Skip empty text nodes
  if (node.nodeType === Node.TEXT_NODE && !node.nodeValue?.trim()) {
    return true;
  }

  // If node has more than 1 meaningful child, it's not a single branch
  const meaningfulChildren = Array.from(node.childNodes).filter(
    child => !(child.nodeType === Node.TEXT_NODE && !child.nodeValue?.trim())
  );

  if (meaningfulChildren.length > 1) {
    return false;
  }

  // If no children, we're at a leaf node
  if (meaningfulChildren.length === 0) {
    return true;
  }

  // Recurse on single child
  return checkNode(meaningfulChildren[0]);
}

const isSimpleTextRenderer = (isSimpleStructure: boolean, parentOverflow: string, textOverflowEllipsis: boolean, nestedTable: boolean, textStyle: Record<string, string>): boolean => {
  if (nestedTable && parentOverflow === 'hidden') {
    return false;
  }
  if ((isSimpleStructure && parentOverflow !== 'visible') || textOverflowEllipsis || nestedTable) {
    return true;
  }
  return false;
}

export const transformHtmlString = (htmlString: string, textStyle: Record<string, string>, parentWidth: number, parentOverflow: string, textOverflowEllipsis: boolean, nestedTable: boolean): string => {
  const parser = new DOMParser();
  const cleaned = cleanInlineTags(htmlString);
  const doc = parser.parseFromString(cleaned, 'text/html');
  const isSimpleStructure = checkNode(doc.body);
  const processor = isSimpleTextRenderer(isSimpleStructure, parentOverflow, textOverflowEllipsis, nestedTable, textStyle) ? new SimpleTextProcessor() : new ComplexTextProcessor();

  function wrapTextNodes(node: Node, currentParentWidth: number): void {
    if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.trim()) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = processor.processText(node.nodeValue, currentParentWidth, textOverflowEllipsis, textStyle);
      node.parentNode?.replaceChild(wrapper.firstChild!, node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Adjust parentWidth if node is an li element
      let newParentWidth = currentParentWidth;
      if (node.nodeName === 'LI') {
        newParentWidth -= 40;
      }
      Array.from(node.childNodes).forEach(childNode => wrapTextNodes(childNode, newParentWidth));
    }
  }

  function cleanInlineTags(htmlString: string): string {
    const inlineTags = ['custom-timer', 'a', 'abbr', 'acronym', 'b', 'bdo', 'big', 'cite', 'dfn', 'em', 'i', 'kbd', 'label', 'q', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'tt', 'var'];
    const inlineTagsPattern = new RegExp(`</?(${inlineTags.join('|')})[^>]*>`, 'gi');
    return htmlString.replace(inlineTagsPattern, '');
  }

  doc.body.childNodes.forEach(node => wrapTextNodes(node, parentWidth));
  return doc.body.innerHTML;
};